import React, { HTMLAttributes } from 'react';
import { t } from 'utils';
import styles from './Card.module.scss';

export interface ICardProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
}

const Card: React.FC<ICardProps> = (props) => {
  const { title, children } = props;

  return (
    <div className={styles.root}>
      <h3 className={styles.title}>{t(title)}</h3>
      {children}
    </div>
  );
};

export default Card;
